import HttpClient from "./http-client";
import { getApiUrl, getCurrentLanguageId } from "./common";
import { tryGetProductId } from "./product-detail";

export default class TronLogeEventLogger {

    private registerAttemptCount = 0;

    public init(): void {
        window.setTimeout(this.registerListener, 200);
    }


    private registerListener() {
        if (window.tronlogo!=undefined) {
            window.tronlogo.registerForTronLogoEvents((eventData) => TronLogeEventLogger.tronLogoListener(eventData));
        } 
        else {
            this.registerAttemptCount++;
            if (this.registerAttemptCount<10) { 
                window.setTimeout(this.registerListener, 200); 
            }
        }
    }

    public static async tronLogoListener(eventData: any): Promise<void>{
        const httpClient = new HttpClient();
        const productId = tryGetProductId();
        const payload = JSON.stringify(eventData);
        eventData.payload = payload;
        if(productId){
            eventData.productId = productId;
        }
        const languageId = getCurrentLanguageId();
        const url = `${getApiUrl()}/log/tronlogoevent`;
        await httpClient.fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Current-Language-Id': languageId
            },
            body: JSON.stringify(eventData)
        }, () => { });
    }

}
